<template>
  <v-app>
    <v-container fluid >
      <v-row align="center" justify="center" v-if="isLoading">
        <v-col class="text-subtitle-1 text-center" cols="12">
          We're getting your card ready, please wait...
        </v-col>
        <v-col cols="12" sm="8" md="4">
          <div class="text-center mt-15">
            <v-progress-linear indeterminate rounded height="6"/>
          </div>
        </v-col>
      </v-row>

      <v-card v-else class="mx-auto" flat align="center" justify="center">
        <v-card-text>
          <v-row class="fill-height"
                 justify="center"
                 align="center">
          <v-img :src="imageSrc" alt="Your Membership Card"
                 aspect-ratio="1.333"
                 max-width="800"
                 max-height="600"
                 contain/>
          </v-row>
          <v-row class="d-flex justify-center " v-if="imageSrc">
            <v-btn color="primary"
                   @click="downloadCard">Download Card</v-btn>
          </v-row>
        </v-card-text>
      </v-card>


    </v-container>
  </v-app>

</template>

<script>
import axios from 'axios';

export default {
  name: "MyMembershipCard",
  props: ['year', 'month', 'day', 'guid'],
  data() {
    return {
      isLoading: false,
      imageSrc: null,
      blob: null,
    }
  },
  methods: {
    getCardImage() {
      this.isLoading = true;
      axios({
        url: `${axios.defaults.baseURL}customer/membershipcard/${this.year}/${this.month}/${this.day}/${this.guid}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const contentType = response.headers['content-type'];
        const blob = new Blob([response.data], {type: contentType});
        this.blob = blob;
        this.imageSrc = URL.createObjectURL(blob);
        this.isLoading = false;
      });
    },
    downloadCard(){
      const FileSaver = require('file-saver');
      FileSaver.saveAs(this.blob, "AcciSureMembershipCard.png");
    }
  },
  mounted() {
    this.getCardImage();
  },
}
</script>

<style scoped>

</style>
